// extracted by mini-css-extract-plugin
module.exports = {"header":"HotModal_style_header__2-ZUu","main":"HotModal_style_main__2MO0q","img":"HotModal_style_img__z_i-p"};